module.exports = __webpack_public_path__ + "img/icon_carica.f8f1590b.png";